;(function ($) {
  "use strict"

  $(".spinner .spinner-up").on("click", function (event) {
    const widget = $(this).parent().parent()
    const input = $("input", widget)
    const quantity = parseInt(input.val(), 10) + 1
    const maxValue = widget.data("max-value")
    event.preventDefault()

    if (maxValue === undefined || quantity <= maxValue) {
      input.val(quantity)
      widget.trigger("spin.bop.spinner", { value: quantity })
    } else {
      widget.trigger("bounce-max.bop.spinner", { value: quantity - 1 })
    }
  })

  $(".spinner .spinner-down").on("click", function (event) {
    const widget = $(this).parent().parent()
    const input = $("input", widget)
    const quantity = parseInt(input.val(), 10) - 1
    event.preventDefault()

    if (quantity > 0) {
      input.val(quantity)

      widget.trigger("spin.bop.spinner", { value: quantity })
    } else {
      widget.trigger("bounce-min.bop.spinner", { value: quantity + 1 })
    }
  })
})(jQuery)
